/**
 * Создает функцию периодического опроса слайдов с заданными условиями
 * 
 * @param {Array} slides - Массив слайдов для проверки
 * @param {Function} filterCondition - Функция фильтрации слайдов
 * @param {Function} dispatch - Redux dispatch функция
 * @param {Function} fetchSlideById - Действие для получения слайда по ID
 * @param {number} interval - Интервал проверки в миллисекундах (по умолчанию 10000)
 * @param {string} logPrefix - Префикс для логирования (по умолчанию '')
 * @returns {Function} Функция очистки (cleanup) для отмены таймеров
 */
export const createSlidePollingEffect = (
    slides, 
    filterCondition, 
    dispatch, 
    fetchSlideById, 
    interval = 10000, 
    logPrefix = ''
) => {
    if (!slides) return () => {};

    const filteredSlides = slides.filter(filterCondition);
    
    if (filteredSlides.length === 0) {
        return () => {};
    }

    const checkSlides = () => {
        filteredSlides.forEach(slide => {
            dispatch(fetchSlideById(slide.id));
        });
    };

    // Первая проверка через 5 секунд (даем время на инициализацию)
    const initialTimeout = setTimeout(checkSlides, 5000);
    
    // Затем периодически каждые interval миллисекунд
    const intervalId = setInterval(checkSlides, interval);
    
    // Возвращаем cleanup функцию для отмены таймеров
    return () => {
        clearTimeout(initialTimeout);
        clearInterval(intervalId);
    };
};
